import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
/**
 * <p>Adds a query string to the provided URL using the params object</p>
 * <p>e.g. Input => URL: www.sample.com, params = {userId: 56, name: "Jonas"}</p>
 *      Output => www.sample.com?userId=56&name=Jonas
 * @param url The url that will contain the query string
 * @param params The object that will be transformed into a query string
 * @return A new url instance containing the query string
 * */
export var appendQueryString = function appendQueryString(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Object.keys(params).length === 0) throw "The params object can't be empty";
  var urlWithQueryString = new URL(url);
  for (var key in params) urlWithQueryString.searchParams.append(key, "".concat(params[key]));
  return urlWithQueryString;
};
export function setParam(key, value, url) {
  if (!url) url = window.location.href.replace(window.location.hash, "");
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf("?") !== -1 ? "&" : "?";
  if (url.match(re)) {
    return url.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return url + separator + key + "=" + value;
  }
}
export function removeParam(key, url) {
  if (!url) url = window.location.href.replace(window.location.hash, "");
  var urlObj = new URL(url);
  var params = new URLSearchParams(urlObj.search);
  params.delete(key);
  urlObj.search = params.toString();
  return urlObj.toString();
}
export function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  if (uri.match(re)) {
    return value ? uri.replace(re, "$1" + key + "=" + value + "$2") : uri.replace(re, (a, b) => {
      var multiple = uri.indexOf("&") !== -1;
      return multiple ? b : "";
    });
  } else {
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    return value ? uri + separator + key + "=" + value : uri;
  }
}